module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "updateEmail"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "email",
      "data-vv-rules": 'required|email',
      "data-vv-name": "new_email",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.securityPreferencesChangeEmail'),
      "errorText": _vm.errors.first('new_email'),
      "label": _vm.$t('message.securityPreferencesChangeEmail'),
      "hintText": _vm.$t('message.placeholderEmail'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.new_email),
      callback: function($$v) {
        _vm.$set(_vm.model, "new_email", $$v)
      },
      expression: "model.new_email"
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "large",
    attrs: {
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.updatingText') : _vm.$t('message.securityPreferencesSendVerificationEmail'),
      "fullWidth": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a577e09","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EmailUpdate/EmailUpdate.vue
// module id = 3185
// module chunks = 1